module.exports = __webpack_public_path__ + "img/absolut-first-block-bg.dd51d435.png";